import callRequestLahiFormBase from '../call-request-lahi-form-base/call-request-lahi-form-base.vue';
export default {
	extends: callRequestLahiFormBase
};
